/* Kabuk Colony: kurumsal ürünler, Dükkan filtresi, Teklif Al ve Set oluştur sayfalarının ortak davranışı.
   Set, ziyaretçinin tarayıcısında saklanır; Dükkan, ürün sayfası ve Set oluştur arasında gezerken kaybolmaz. */
(function () {
  if (window.KCK) return;
  var KCK = (window.KCK = {});

  var SET_KEY = 'kck-set';
  var HAZIR_KEY = 'kck-hazir';
  var BUILDER_KEY = 'kck-builder';
  var LAST_FORM_KEY = 'kck-last-form';

  function all(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function read(key, fallback) {
    try {
      var value = JSON.parse(window.localStorage.getItem(key));
      return value === null || value === undefined ? fallback : value;
    } catch (error) {
      return fallback;
    }
  }

  function write(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {}
  }

  function session(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      if (value === null) window.sessionStorage.removeItem(key);
      else window.sessionStorage.setItem(key, value);
    } catch (error) {}
    return null;
  }

  function fill(template, n) {
    return String(template || '[n]').replace('[n]', n);
  }

  function number(n) {
    try {
      return Number(n).toLocaleString('tr-TR');
    } catch (error) {
      return String(n);
    }
  }

  function param(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (error) {
      return '';
    }
  }

  function scrollTo(element) {
    if (!element || !element.getBoundingClientRect) return;
    var header = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'), 10) || 0;
    var top = element.getBoundingClientRect().top + window.pageYOffset - header - 16;
    window.scrollTo(0, Math.max(0, top));
  }

  /* Sayfaya yeni mi gelindi, yoksa yenilendi ya da geri tuşuyla mı dönüldü */
  function arrival() {
    try {
      var entry = window.performance.getEntriesByType('navigation')[0];
      return entry && entry.type ? entry.type : 'navigate';
    } catch (error) {
      return 'navigate';
    }
  }

  /* Kartları seçilen sıraya dizer. Her kartın ilk sırası kckIndex'te durur; "Önerilen" o sıraya döner.
     Fiyatı olmayan kartlar (kurumsal ürünler) fiyat sıralamasında sona kalır. */
  function sortCards(grid, cards, mode) {
    function value(card, name) {
      var raw = card.getAttribute(name);
      var n = raw === null || raw === '' ? NaN : parseFloat(raw);
      return isNaN(n) ? null : n;
    }
    var list = cards.slice().sort(function (a, b) {
      var result = 0;
      if (mode === 'az' || mode === 'za') {
        result = String(a.getAttribute('data-title') || '').localeCompare(String(b.getAttribute('data-title') || ''), 'tr');
        if (mode === 'za') result = -result;
      } else if (mode === 'yeni') {
        result = (value(b, 'data-date') || 0) - (value(a, 'data-date') || 0);
      } else if (mode === 'fiyat-artan' || mode === 'fiyat-azalan') {
        var pa = value(a, 'data-price');
        var pb = value(b, 'data-price');
        if (pa === null || pb === null) result = pa === pb ? 0 : pa === null ? 1 : -1;
        else result = mode === 'fiyat-artan' ? pa - pb : pb - pa;
      }
      return result || a.kckIndex - b.kckIndex;
    });
    list.forEach(function (card) {
      grid.appendChild(card);
    });
    return list;
  }

  function replay(element) {
    if (!element) return;
    element.classList.remove('kck-view');
    void element.offsetWidth;
    element.classList.add('kck-view');
  }

  /* ---------- Set: seçilen kurumsal ürünler ---------- */

  var Set = (KCK.set = {
    items: function () {
      var items = read(SET_KEY, []);
      return Array.isArray(items) ? items : [];
    },
    has: function (handle) {
      return Set.items().some(function (item) {
        return item.handle === handle;
      });
    },
    toggle: function (item) {
      var items = Set.items();
      var next = items.filter(function (entry) {
        return entry.handle !== item.handle;
      });
      if (next.length === items.length) next.push(item);
      Set.save(next);
    },
    remove: function (handle) {
      Set.save(
        Set.items().filter(function (entry) {
          return entry.handle !== handle;
        })
      );
    },
    save: function (items) {
      write(SET_KEY, items);
      document.dispatchEvent(new CustomEvent('kck:set'));
    },
  });

  function syncAddButtons() {
    all(document, '[data-kck-add]').forEach(function (button) {
      var on = Set.has(button.getAttribute('data-handle'));
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = button.getAttribute(on ? 'data-on' : 'data-off');
      if (label) button.textContent = label;
      var card = button.closest('.kck-item');
      if (card) card.setAttribute('data-on', on ? 'true' : 'false');
    });
    all(document, '[data-kck-inset]').forEach(function (element) {
      element.hidden = !Set.has(element.getAttribute('data-kck-inset'));
    });
  }

  function syncBar() {
    var count = Set.items().length;
    var onBuilder = !!document.querySelector('[data-kck-builder]');
    all(document, '[data-kck-bar]').forEach(function (bar) {
      var show = count > 0 && !onBuilder && !document.body.classList.contains('kck-quote-open');
      bar.hidden = !show;
      var text = bar.querySelector('[data-kck-bar-text]');
      if (text) text.textContent = fill(bar.getAttribute('data-text'), count);
      document.body.style.setProperty('--kck-bar-space', show ? bar.offsetHeight + 'px' : '0px');
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-kck-add]') : null;
    if (!button) return;
    event.preventDefault();
    Set.toggle({
      handle: button.getAttribute('data-handle'),
      title: button.getAttribute('data-title'),
      cat: button.getAttribute('data-cat') || '',
      url: button.getAttribute('data-url') || '',
      image: button.getAttribute('data-image') || '',
    });
  });

  document.addEventListener('kck:set', function () {
    syncAddButtons();
    syncBar();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === SET_KEY) document.dispatchEvent(new CustomEvent('kck:set'));
  });

  /* Geri tuşuyla dönülen sayfa bellekten gelir; o arada değişen set yeniden okunur */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) document.dispatchEvent(new CustomEvent('kck:set'));
  });

  /* ---------- Seçim kutucukları (tekli ya da çoklu; "Diğer" seçilince yazı alanı açılır) ---------- */

  function initPick(group) {
    if (group.kckBound) return;
    group.kckBound = true;
    var multi = group.getAttribute('data-kck-pick') === 'multi';
    var chips = all(group, '[data-value]');
    var input = group.querySelector('[data-kck-pick-input]');
    var otherWrap = group.querySelector('[data-kck-pick-other]');
    var otherInput = otherWrap ? otherWrap.querySelector('input, textarea') : null;

    function sync(focusOther) {
      var picked = [];
      var otherOn = false;
      chips.forEach(function (chip) {
        if (chip.getAttribute('aria-pressed') !== 'true') return;
        picked.push(chip.getAttribute('data-value'));
        if (chip.hasAttribute('data-other')) otherOn = true;
      });
      if (input) input.value = picked.join(', ');
      if (otherWrap) {
        otherWrap.hidden = !otherOn;
        if (otherInput && !otherOn) otherInput.value = '';
        if (otherInput && otherOn && focusOther) otherInput.focus();
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var on = chip.getAttribute('aria-pressed') !== 'true';
        if (!multi) {
          chips.forEach(function (other) {
            other.setAttribute('aria-pressed', 'false');
          });
        }
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        sync(on && chip.hasAttribute('data-other'));
      });
    });
    sync(false);
  }

  /* ---------- Formlar ---------- */

  function initForm(form) {
    if (form.kckBound) return;
    form.kckBound = true;
    form.addEventListener('submit', function () {
      session(LAST_FORM_KEY, form.getAttribute('data-kck-form') || '');
      var body = form.querySelector('[name="contact[body]"]');
      if (body && !String(body.value || '').trim()) body.value = form.getAttribute('data-empty-body') || '-';
      var submit = form.querySelector('[type="submit"]');
      if (submit) {
        window.setTimeout(function () {
          submit.disabled = true;
        }, 0);
      }
    });
  }

  /* ---------- Görünümler: aynı sayfada açılan form ve "gönderildi" ekranları ---------- */

  function initViews(root) {
    if (root.kckBound) return;
    root.kckBound = true;
    var views = all(root, '[data-kck-view]').filter(function (view) {
      return view.closest('[data-kck-views]') === root;
    });
    var useHash = root.hasAttribute('data-kck-hash');

    function show(name, scroll) {
      var found = false;
      views.forEach(function (view) {
        var on = view.getAttribute('data-kck-view') === name;
        view.hidden = !on;
        if (on) {
          found = true;
          replay(view);
        }
      });
      if (!found && views[0]) views[0].hidden = false;
      if (scroll) scrollTo(root);
    }

    root.kckShow = show;

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest ? event.target.closest('[data-kck-go]') : null;
      if (!trigger || trigger.closest('[data-kck-views]') !== root) return;
      event.preventDefault();
      var name = trigger.getAttribute('data-kck-go');
      show(name, true);
      if (useHash && window.history && window.history.replaceState) {
        var first = views[0] ? views[0].getAttribute('data-kck-view') : '';
        window.history.replaceState(null, '', name === first ? window.location.pathname + window.location.search : '#' + name);
      }
    });

    var initial = root.getAttribute('data-kck-initial') || '';
    var done = root.querySelector('[data-kck-view="done"]');
    if (initial === 'done' && done) {
      var last = session(LAST_FORM_KEY) || '';
      var text = done.querySelector('[data-kck-done-text]');
      if (text && last && text.getAttribute('data-text-' + last)) text.textContent = text.getAttribute('data-text-' + last);
      show('done', false);
      window.setTimeout(function () {
        scrollTo(root);
      }, 150);
      return;
    }
    if (initial === 'error') {
      var failed = session(LAST_FORM_KEY) || '';
      if (failed && root.querySelector('[data-kck-view="' + failed + '"]')) {
        show(failed, false);
        return;
      }
    }
    var hash = (window.location.hash || '').replace('#', '');
    if (useHash && hash && root.querySelector('[data-kck-view="' + hash + '"]')) {
      show(hash, false);
      return;
    }
    show(views[0] ? views[0].getAttribute('data-kck-view') : '', false);
  }

  /* ---------- Ürün sayfası: galeri ---------- */

  function initGallery(root) {
    if (root.kckBound) return;
    root.kckBound = true;
    var slides = all(root, '.kck-gal__slide');
    var thumbs = all(root, '[data-kck-thumb]');
    if (slides.length < 2) return;
    var index = 0;
    var timer = null;
    var seconds = parseFloat(root.getAttribute('data-seconds')) || 3.5;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = root.getAttribute('data-auto') === 'true' && !still;

    function go(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-on', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (!auto) return;
      timer = window.setInterval(function () {
        go(index + 1);
      }, seconds * 1000);
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        go(i);
        start();
      });
    });
    var prev = root.querySelector('[data-kck-prev]');
    var next = root.querySelector('[data-kck-next]');
    if (prev) {
      prev.addEventListener('click', function () {
        go(index - 1);
        start();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        go(index + 1);
        start();
      });
    }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    go(0);
    start();
  }

  /* ---------- Ürün sayfası: ürün / teklif formu / gönderildi ---------- */

  function productView(name) {
    var parts = all(document, '[data-kck-pv]');
    if (!parts.length) return false;
    var has = parts.some(function (part) {
      return part.getAttribute('data-kck-pv') === name;
    });
    if (!has) return false;
    parts.forEach(function (part) {
      var on = part.getAttribute('data-kck-pv') === name;
      part.hidden = !on;
      if (on && name !== 'product') replay(part);
    });
    document.body.classList.toggle('kck-quote-open', name !== 'product');
    syncBar();
    return true;
  }

  KCK.productView = productView;

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var open = event.target.closest('[data-kck-quote-open]');
    var close = event.target.closest('[data-kck-quote-close]');
    if (open && document.querySelector('[data-kck-pv="quote"]')) {
      event.preventDefault();
      productView('quote');
      scrollTo(document.querySelector('[data-kck-pv="quote"]'));
      if (window.history && window.history.replaceState) window.history.replaceState(null, '', '#teklif');
    } else if (close && document.querySelector('[data-kck-pv="product"]')) {
      event.preventDefault();
      productView('product');
      window.scrollTo(0, 0);
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search.replace(/[?&]contact_posted=true/, ''));
      }
    }
  });

  function initProduct() {
    var main = document.querySelector('[data-kck-product]');
    if (!main || main.kckBound) return;
    main.kckBound = true;
    var initial = main.getAttribute('data-kck-initial') || 'product';
    if (initial === 'product' && window.location.hash === '#teklif') initial = 'quote';
    productView(initial);
    if (initial !== 'product') {
      window.setTimeout(function () {
        scrollTo(document.querySelector('[data-kck-pv="' + initial + '"]'));
      }, 150);
    }
  }

  /* Köşeli parantezli notlar gizlendiğinde boş kalan paragraf ve başlıkları temizler */
  function tidyProse(root) {
    all(root, 'p, li').forEach(function (node) {
      if (!node.textContent.trim() && !node.querySelector('img')) node.remove();
    });
    all(root, 'ul, ol').forEach(function (list) {
      if (!list.children.length) list.remove();
    });
    all(root, 'h2, h3').forEach(function (heading) {
      var next = heading.nextElementSibling;
      if (!next || /^H[23]$/.test(next.tagName)) heading.remove();
    });
  }

  /* ---------- Dükkan: sekmeler ve kategori filtresi ---------- */

  function initDukkan(root) {
    if (root.kckBound) return;
    root.kckBound = true;
    var tabs = all(root, '[data-kck-tab]');
    var cats = all(root, '[data-kck-cat]');
    var cards = all(root, '.kck-prod');
    var catsWrap = root.querySelector('[data-kck-cats]');
    var notes = all(root, '[data-kck-note]');
    var count = root.querySelector('[data-kck-count]');
    var bulk = root.querySelector('[data-kck-bulk]');
    var empty = root.querySelector('[data-kck-empty]');
    var sort = root.querySelector('[data-kck-sort]');
    var grid = cards.length ? cards[0].parentNode : null;
    var state = { tab: 'tum', cat: 'tum', sort: 'onerilen' };
    cards.forEach(function (card, index) {
      card.kckIndex = index;
    });

    /* Kategoriler: sekme varsa yalnızca "Kurumsal ürünler" sekmesinde, sekme yoksa (yalnızca kurumsal ürün) hep açık */
    function catsOn() {
      return tabs.length ? state.tab === 'kurumsal' : cats.length > 0;
    }

    function apply(animate) {
      var shown = 0;
      cards.forEach(function (card) {
        var kind = card.getAttribute('data-kind');
        var ok = state.tab === 'tum' || kind === state.tab;
        if (ok && catsOn() && state.cat !== 'tum') ok = card.getAttribute('data-cat') === state.cat;
        card.hidden = !ok;
        card.classList.remove('is-in');
        if (ok) {
          card.style.setProperty('--kck-i', Math.min(shown, 12));
          shown += 1;
        }
      });
      if (animate) {
        void root.offsetWidth;
        cards.forEach(function (card) {
          if (!card.hidden) card.classList.add('is-in');
        });
      }
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-pressed', tab.getAttribute('data-kck-tab') === state.tab ? 'true' : 'false');
      });
      cats.forEach(function (cat) {
        cat.setAttribute('aria-pressed', cat.getAttribute('data-kck-cat') === state.cat ? 'true' : 'false');
      });
      if (catsWrap) catsWrap.hidden = !catsOn();
      notes.forEach(function (note) {
        note.hidden = note.getAttribute('data-kck-note') !== state.tab;
      });
      if (bulk) bulk.hidden = state.tab !== 'dukkan';
      if (empty) empty.hidden = shown > 0;
      if (count) count.textContent = fill(count.getAttribute('data-text'), shown);

      if (window.history && window.history.replaceState && (tabs.length || cats.length || sort)) {
        var query = [];
        if (state.tab !== 'tum') query.push('tur=' + state.tab);
        if (catsOn() && state.cat !== 'tum') query.push('kategori=' + state.cat);
        if (state.sort !== 'onerilen') query.push('sirala=' + state.sort);
        window.history.replaceState(null, '', window.location.pathname + (query.length ? '?' + query.join('&') : ''));
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var name = tab.getAttribute('data-kck-tab');
        /* Seçili sekmeye yeniden basmak karışık listeye döndürür */
        state.tab = state.tab === name ? 'tum' : name;
        state.cat = 'tum';
        apply(true);
      });
    });
    cats.forEach(function (cat) {
      cat.addEventListener('click', function () {
        state.cat = cat.getAttribute('data-kck-cat');
        apply(true);
      });
    });

    if (sort && grid) {
      var wantedSort = param('sirala');
      if (wantedSort && sort.querySelector('option[value="' + wantedSort.replace(/[^a-z-]/g, '') + '"]')) sort.value = wantedSort;
      state.sort = sort.value || 'onerilen';
      if (state.sort !== 'onerilen') cards = sortCards(grid, cards, state.sort);
      sort.addEventListener('change', function () {
        state.sort = sort.value || 'onerilen';
        cards = sortCards(grid, cards, state.sort);
        apply(true);
      });
    }

    if (tabs.length) {
      var wantedTab = param('tur');
      if (wantedTab === 'kurumsal' || wantedTab === 'dukkan') state.tab = wantedTab;
    }
    var wantedCat = param('kategori').replace(/[^a-z0-9-]/g, '');
    if (catsOn() && wantedCat && root.querySelector('[data-kck-cat="' + wantedCat + '"]')) state.cat = wantedCat;
    apply(true);
  }

  /* ---------- Set oluştur: iki yol, adımlar, özetler ---------- */

  function initBuilder(root) {
    if (root.kckBound) return;
    root.kckBound = true;

    var text = {
      sets: root.getAttribute('data-text-sets') || '[n] set',
      products: root.getAttribute('data-text-products') || '[n] ürün',
      pieces: root.getAttribute('data-text-pieces') || '[n] adet',
      none: root.getAttribute('data-text-none') || 'Seçilmedi',
      otherPack: root.getAttribute('data-text-other-pack') || 'Farklı bir paketleme',
      allCats: root.getAttribute('data-text-all') || 'Tüm kurumsal ürünler',
      remove: root.getAttribute('data-text-remove') || 'Çıkar',
      warnPack: root.getAttribute('data-warn-pack') || '',
      warnItems: root.getAttribute('data-warn-items') || '',
      warnHazir: root.getAttribute('data-warn-hazir') || '',
    };
    /* Set yolunun adımları iki sırada gösterilebilir. Görünümler içeriğe göre adlıdır:
       set1 ürünler, set2 adet ve paketleme, set3 bilgiler. state.step görünümün numarasıdır, sıradaki yeri değil. */
    var ORDERS = { urun: ['set1', 'set2', 'set3'], paket: ['set2', 'set1', 'set3'] };
    var orderDefault = ORDERS[root.getAttribute('data-order-default')] ? root.getAttribute('data-order-default') : 'paket';
    var orderShop = ORDERS[root.getAttribute('data-order-shop')] ? root.getAttribute('data-order-shop') : 'urun';
    var lastView = '';
    var defaultQty = root.getAttribute('data-default-qty') || '';
    var saved = read(BUILDER_KEY, {});
    /* Eski kayıttaki adım numarası başka anlamdaydı; kullanılmaz */
    if (saved.v !== 2) saved.step = 0;
    var state = {
      mode: saved.mode === 'hazir' ? 'hazir' : 'set',
      order: ORDERS[saved.order] ? saved.order : orderDefault,
      step: saved.step > 0 && saved.step < 4 ? saved.step : 0,
      hzStep: saved.hzStep > 0 && saved.hzStep < 3 ? saved.hzStep : 1,
      qty: saved.qty || defaultQty,
      customQty: saved.customQty || '',
      packs: Array.isArray(saved.packs) ? saved.packs : [],
      packOther: saved.packOther || '',
      cat: 'tum',
      done: '',
    };
    var hazir = read(HAZIR_KEY, {});
    if (!hazir || typeof hazir !== 'object' || Array.isArray(hazir)) hazir = {};

    var views = all(root, '[data-kck-bview]');
    var qtyChips = all(root, '[data-kck-qty]');
    var qtyInput = root.querySelector('[data-kck-qty-custom]');
    var packButtons = all(root, '[data-kck-pack]');
    var packOtherInput = root.querySelector('[data-kck-pack-other-input]');
    var packOtherWrap = root.querySelector('[data-kck-pack-other-wrap]');
    var items = all(root, '.kck-item[data-kck-corp]');
    var hzItems = all(root, '.kck-item[data-kck-hz]');

    /* Ürün kartlarını soldaki kategori sırasına dizer */
    var catOrder = all(root, '[data-kck-bcat]').map(function (button) {
      return button.getAttribute('data-kck-bcat');
    });
    if (items.length && catOrder.length > 1) {
      var grid = items[0].parentNode;
      items
        .map(function (item, index) {
          var at = catOrder.indexOf(item.getAttribute('data-cat'));
          return { item: item, index: index, at: at < 0 ? 999 : at };
        })
        .sort(function (a, b) {
          return a.at - b.at || a.index - b.index;
        })
        .forEach(function (entry) {
          grid.appendChild(entry.item);
        });
    }

    all(root, '[data-kck-sort]').forEach(function (select) {
      var view = select.closest('[data-kck-bview]');
      var grid = view ? view.querySelector('.kck-grid') : null;
      if (!grid) return;
      var cards = all(grid, '.kck-item');
      cards.forEach(function (card, index) {
        card.kckIndex = index;
      });
      if (select.value && select.value !== 'onerilen') sortCards(grid, cards, select.value);
      select.addEventListener('change', function () {
        sortCards(grid, cards, select.value);
        grid.style.setProperty('--kck-dir', 0);
        replay(grid);
      });
    });

    var packLabels = packButtons.map(function (button) {
      return button.getAttribute('data-kck-pack');
    });
    state.packs = state.packs.filter(function (label) {
      return packLabels.indexOf(label) > -1;
    });
    if (state.qty !== 'custom' && !qtyChips.some(function (chip) { return chip.getAttribute('data-kck-qty') === String(state.qty); })) {
      state.qty = defaultQty;
    }

    /* Listede artık olmayan ürünleri saklanan seçimden düşürür */
    var known = {};
    hzItems.forEach(function (item) {
      known[item.getAttribute('data-handle')] = item.getAttribute('data-title');
    });
    Object.keys(hazir).forEach(function (handle) {
      if (!known[handle] || !(hazir[handle] > 0)) delete hazir[handle];
    });

    function persist() {
      write(BUILDER_KEY, {
        v: 2,
        mode: state.mode,
        order: state.order,
        step: state.step,
        hzStep: state.hzStep,
        qty: state.qty,
        customQty: state.customQty,
        packs: state.packs,
        packOther: state.packOther,
      });
      write(HAZIR_KEY, hazir);
    }

    function qtyText() {
      if (state.qty === 'custom') return state.customQty ? fill(text.sets, number(state.customQty)) : text.none;
      return state.qty ? fill(text.sets, state.qty) : text.none;
    }

    function packList() {
      return state.packs.map(function (label) {
        var button = packButtons.filter(function (entry) {
          return entry.getAttribute('data-kck-pack') === label;
        })[0];
        if (button && button.hasAttribute('data-kck-pack-other')) return state.packOther.trim() || text.otherPack;
        return (button && button.getAttribute('data-short')) || label;
      });
    }

    function warn(name, message) {
      all(root, '[data-kck-warn="' + name + '"]').forEach(function (element) {
        element.textContent = message || '';
        element.hidden = !message;
      });
    }

    function currentView() {
      if (state.done) return 'done-' + state.done;
      if (state.mode === 'hazir') return 'hz' + state.hzStep;
      return 'set' + state.step;
    }

    function seq() {
      return ORDERS[state.order];
    }

    function firstStep() {
      return parseInt(seq()[0].slice(3), 10);
    }

    /* Son adımdan önce eksik kalan ilk adım: [görünüm, uyarı] ya da null */
    function missing() {
      var gaps = seq().filter(function (view) {
        if (view === 'set1') return Set.items().length === 0;
        if (view === 'set2') return state.packs.length === 0;
        return false;
      });
      if (!gaps.length) return null;
      return [gaps[0], gaps[0] === 'set1' ? text.warnItems : text.warnPack];
    }

    /* Adım düğmelerini seçili sıraya dizer, yalnızca o sıraya ait düğmeleri gösterir */
    function applyOrder() {
      var wrap = root.querySelector('[data-kck-steps="set"]');
      if (wrap) {
        var lines = all(wrap, '.kck-step__line');
        seq().forEach(function (view, i) {
          var button = wrap.querySelector('[data-kck-to="' + view + '"]');
          if (!button) return;
          wrap.appendChild(button);
          if (lines[i]) wrap.appendChild(lines[i]);
        });
      }
      all(root, '[data-kck-order-only]').forEach(function (element) {
        element.hidden = element.getAttribute('data-kck-order-only') !== state.order;
      });
      root.setAttribute('data-kck-order', state.order);
    }

    /* Adımların üstündeki yıldız, bulunulan adımın üstüne yuvarlanır */
    function roll() {
      all(root, '[data-kck-steps]').forEach(function (wrap) {
        var star = wrap.querySelector('[data-kck-roller]');
        if (!star || wrap.hidden) return;
        var active = wrap.querySelector('.kck-step[data-state="active"] i');
        if (!active) {
          star.style.opacity = '0';
          return;
        }
        var box = wrap.getBoundingClientRect();
        var dot = active.getBoundingClientRect();
        var x = Math.round(dot.left - box.left + dot.width / 2 - star.offsetWidth / 2);
        star.style.opacity = '1';
        star.style.transform = 'translateX(' + x + 'px) rotate(' + Math.round(x * 1.5) + 'deg)';
        if (!star.kckPlaced) {
          /* İlk yerleşimde yuvarlanmaz, yerinde belirir */
          star.kckPlaced = true;
          star.style.transition = 'none';
          void star.offsetWidth;
          star.style.transition = '';
        }
      });
    }

    function render(scroll) {
      var name = currentView();
      /* İleri adım sağdan, geri adım soldan gelir; sekme değişince aşağıdan belirir */
      var dir = 0;
      var viewOrder = seq().concat(['hz1', 'hz2']);
      var from = viewOrder.indexOf(lastView);
      var to = viewOrder.indexOf(name);
      if (from > -1 && to > -1 && from !== to && lastView.slice(0, 2) === name.slice(0, 2)) dir = to > from ? 1 : -1;
      /* Önce yeni adım açılır, sonra eskisi kapanır: arada sayfa boşalıp en başa sıçramaz */
      views.forEach(function (view) {
        if (view.getAttribute('data-kck-bview') !== name || !view.hidden) return;
        view.hidden = false;
        view.style.setProperty('--kck-dir', dir);
        replay(view);
      });
      views.forEach(function (view) {
        if (view.getAttribute('data-kck-bview') !== name) view.hidden = true;
      });
      lastView = name;

      all(root, '[data-kck-mode]').forEach(function (tab) {
        tab.setAttribute('aria-pressed', tab.getAttribute('data-kck-mode') === state.mode ? 'true' : 'false');
      });
      /* Geçilen adım ancak tamamlandıysa işaretlenir: adımlara basılarak atlanabilir */
      var filledView = { set1: Set.items().length > 0, set2: state.packs.length > 0 };
      var filled = {
        set: seq().map(function (view) {
          return !!filledView[view];
        }),
        hazir: [Object.keys(hazir).length > 0],
      };
      all(root, '[data-kck-steps]').forEach(function (wrap) {
        var kind = wrap.getAttribute('data-kck-steps');
        var mine = kind === state.mode;
        wrap.hidden = !mine;
        var current = kind === 'hazir' ? state.hzStep : seq().indexOf('set' + state.step) + 1;
        if (state.done) current = 99;
        var states = all(wrap, '.kck-step').map(function (step, i) {
          var now = current === i + 1 ? 'active' : current > i + 1 && (state.done || (filled[kind] || [])[i]) ? 'done' : 'todo';
          if (step.getAttribute('data-state') !== now) step.setAttribute('data-state', now);
          if (now === 'active') step.setAttribute('aria-current', 'step');
          else step.removeAttribute('aria-current');
          var dot = step.querySelector('i');
          if (dot) dot.textContent = now === 'done' ? '✓' : String(i + 1);
          return now;
        });
        all(wrap, '.kck-step__line').forEach(function (line, i) {
          line.setAttribute('data-on', states[i] === 'done' ? 'true' : 'false');
        });
      });
      roll();

      qtyChips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', state.qty !== 'custom' && chip.getAttribute('data-kck-qty') === String(state.qty) ? 'true' : 'false');
      });
      if (qtyInput && document.activeElement !== qtyInput) qtyInput.value = state.qty === 'custom' ? state.customQty : '';

      var otherOn = false;
      packButtons.forEach(function (button) {
        var on = state.packs.indexOf(button.getAttribute('data-kck-pack')) > -1;
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && button.hasAttribute('data-kck-pack-other')) otherOn = true;
      });
      if (packOtherWrap) packOtherWrap.hidden = !otherOn;
      if (packOtherInput && document.activeElement !== packOtherInput) packOtherInput.value = state.packOther;

      /* Kategori filtresi */
      var shown = 0;
      items.forEach(function (item) {
        var ok = state.cat === 'tum' || item.getAttribute('data-cat') === state.cat;
        item.hidden = !ok;
        if (ok) shown += 1;
      });
      var title = root.querySelector('[data-kck-grid-title]');
      all(root, '[data-kck-bcat]').forEach(function (button) {
        var on = button.getAttribute('data-kck-bcat') === state.cat;
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && title) title.textContent = button.getAttribute('data-label') || text.allCats;
      });

      /* Set özeti */
      var setItems = Set.items();
      var packs = packList();
      all(root, '[data-kck-sum="pack"]').forEach(function (element) {
        element.textContent = packs.length ? packs.join(' + ') : text.none;
      });
      all(root, '[data-kck-sum="multi"]').forEach(function (element) {
        element.hidden = packs.length < 2;
      });
      all(root, '[data-kck-sum="qty"]').forEach(function (element) {
        element.textContent = qtyText();
      });
      all(root, '[data-kck-sum="count"]').forEach(function (element) {
        element.textContent = fill(text.products, setItems.length);
      });
      all(root, '[data-kck-sum="empty"]').forEach(function (element) {
        element.hidden = setItems.length > 0;
      });
      all(root, '[data-kck-sum="tools"]').forEach(function (element) {
        element.hidden = setItems.length === 0;
      });
      all(root, '[data-kck-sum="items"]').forEach(function (list) {
        var rich = list.hasAttribute('data-rich');
        list.textContent = '';
        setItems.forEach(function (item) {
          var row = document.createElement('div');
          row.className = 'kck-sum__item';
          if (rich) {
            var thumb = document.createElement('span');
            thumb.className = 'kck-sum__thumb';
            if (item.image) {
              var image = document.createElement('img');
              image.src = item.image;
              image.alt = '';
              image.loading = 'lazy';
              thumb.appendChild(image);
            } else {
              var star = document.createElement('span');
              star.className = 'kck-star';
              thumb.appendChild(star);
            }
            row.appendChild(thumb);
          }
          var name = document.createElement('span');
          name.className = 'kck-sum__name';
          name.textContent = item.title;
          if (rich && item.cat) {
            var cat = document.createElement('small');
            cat.textContent = item.cat;
            name.appendChild(cat);
          }
          row.appendChild(name);
          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'kck-x';
          remove.setAttribute('aria-label', item.title + ': ' + text.remove);
          remove.textContent = '✕';
          remove.addEventListener('click', function () {
            Set.remove(item.handle);
          });
          row.appendChild(remove);
          list.appendChild(row);
        });
      });

      /* Hazır ürünler */
      var total = 0;
      var chosen = [];
      hzItems.forEach(function (item) {
        var handle = item.getAttribute('data-handle');
        var n = hazir[handle] || 0;
        item.setAttribute('data-on', n > 0 ? 'true' : 'false');
        var input = item.querySelector('[data-kck-hq]');
        if (input && document.activeElement !== input) input.value = n > 0 ? n : '';
        var flag = item.querySelector('[data-kck-flag]');
        if (flag) flag.hidden = !(n > 0);
        if (n > 0) {
          total += n;
          chosen.push({ handle: handle, title: item.getAttribute('data-title'), n: n });
        }
      });
      all(root, '[data-kck-hsum="empty"]').forEach(function (element) {
        element.hidden = chosen.length > 0;
      });
      all(root, '[data-kck-hsum="tools"]').forEach(function (element) {
        element.hidden = chosen.length === 0;
      });
      /* Sekmelerde, o yolda seçili ürün sayısı */
      all(root, '[data-kck-tabn]').forEach(function (element) {
        var n = element.getAttribute('data-kck-tabn') === 'hazir' ? chosen.length : setItems.length;
        element.hidden = n === 0;
        element.textContent = fill(text.products, n);
      });
      all(root, '[data-kck-hsum="count"]').forEach(function (element) {
        element.textContent = fill(text.pieces, number(total));
      });
      all(root, '[data-kck-hsum="items"]').forEach(function (list) {
        var removable = list.hasAttribute('data-removable');
        list.textContent = '';
        chosen.forEach(function (entry) {
          var row = document.createElement('div');
          row.className = 'kck-sum__item';
          var name = document.createElement('span');
          name.className = 'kck-sum__name';
          name.textContent = entry.title;
          var qty = document.createElement('span');
          qty.className = 'kck-sum__qty';
          qty.textContent = fill(text.pieces, number(entry.n));
          row.appendChild(name);
          row.appendChild(qty);
          if (removable) {
            var remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'kck-x';
            remove.setAttribute('aria-label', entry.title + ': ' + text.remove);
            remove.textContent = '✕';
            remove.addEventListener('click', function () {
              setHazir(entry.handle, 0);
            });
            row.appendChild(remove);
          }
          list.appendChild(row);
        });
      });

      /* Forma eklenen gizli alanlar: e-postada set özeti olarak görünür */
      all(root, '[data-kck-out="qty"]').forEach(function (input) {
        input.value = qtyText();
      });
      all(root, '[data-kck-out="pack"]').forEach(function (input) {
        input.value = packs.join(' + ');
      });
      all(root, '[data-kck-out="items"]').forEach(function (input) {
        input.value = setItems
          .map(function (item) {
            return item.title;
          })
          .join(', ');
      });
      all(root, '[data-kck-out="hitems"]').forEach(function (input) {
        input.value = chosen
          .map(function (entry) {
            return entry.title + ': ' + fill(text.pieces, number(entry.n));
          })
          .join(', ');
      });
      all(root, '[data-kck-out="hcount"]').forEach(function (input) {
        input.value = fill(text.pieces, number(total));
      });

      persist();
      if (scroll) scrollTo(root.querySelector('[data-kck-anchor]') || root);
    }

    function setHazir(handle, n) {
      var value = Math.max(0, Math.min(99999, parseInt(n, 10) || 0));
      if (value > 0) hazir[handle] = value;
      else delete hazir[handle];
      warn('hz1', '');
      /* Son ürün de çıkarıldıysa ürün adımına dönülür */
      var back = state.mode === 'hazir' && state.hzStep === 2 && !state.done && Object.keys(hazir).length === 0;
      if (back) state.hzStep = 1;
      render(back);
    }

    function closeConfirms() {
      all(root, '[data-kck-clear-confirm]').forEach(function (question) {
        question.hidden = true;
      });
      all(root, '[data-kck-clear]').forEach(function (button) {
        button.hidden = false;
      });
    }

    all(root, '[data-kck-mode]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        state.mode = tab.getAttribute('data-kck-mode');
        state.done = '';
        render(false);
      });
    });

    qtyChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        state.qty = chip.getAttribute('data-kck-qty');
        state.customQty = '';
        render(false);
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        /* Yazılan sayı seçili kutucuğun yerine geçer; alan boşalınca varsayılana döner */
        var value = String(qtyInput.value || '').replace(/[^0-9]/g, '').slice(0, 6);
        state.customQty = value;
        state.qty = value ? 'custom' : defaultQty;
        render(false);
      });
    }

    packButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var label = button.getAttribute('data-kck-pack');
        var at = state.packs.indexOf(label);
        if (at > -1) state.packs.splice(at, 1);
        else state.packs.push(label);
        /* Seçim sırası değil, sayfadaki sıra korunur */
        state.packs.sort(function (a, b) {
          return packLabels.indexOf(a) - packLabels.indexOf(b);
        });
        warn('set2', '');
        render(false);
        if (at === -1 && button.hasAttribute('data-kck-pack-other') && packOtherInput) packOtherInput.focus();
      });
    });
    if (packOtherInput) {
      packOtherInput.addEventListener('input', function () {
        state.packOther = String(packOtherInput.value || '').slice(0, 200);
        render(false);
      });
    }

    all(root, '[data-kck-bcat]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.cat = button.getAttribute('data-kck-bcat');
        render(false);
      });
    });

    hzItems.forEach(function (item) {
      var handle = item.getAttribute('data-handle');
      var input = item.querySelector('[data-kck-hq]');
      var minus = item.querySelector('[data-kck-minus]');
      var plus = item.querySelector('[data-kck-plus]');
      if (minus) {
        minus.addEventListener('click', function () {
          setHazir(handle, (hazir[handle] || 0) - 1);
        });
      }
      if (plus) {
        plus.addEventListener('click', function () {
          setHazir(handle, (hazir[handle] || 0) + 1);
        });
      }
      if (input) {
        input.addEventListener('input', function () {
          setHazir(handle, String(input.value || '').replace(/[^0-9]/g, ''));
        });
      }
    });

    /* "Seti boşalt": önce sorar, onaylanınca boşaltır */
    root.addEventListener('click', function (event) {
      if (!event.target.closest) return;
      var box = event.target.closest('[data-kck-clearbox]');
      if (!box) return;
      var question = box.querySelector('[data-kck-clear-confirm]');
      var ask = box.querySelector('[data-kck-clear]');
      if (event.target.closest('[data-kck-clear]')) {
        closeConfirms();
        if (question) question.hidden = false;
        if (ask) ask.hidden = true;
        var yes = box.querySelector('[data-kck-clear-yes]');
        if (yes) yes.focus();
      } else if (event.target.closest('[data-kck-clear-no]')) {
        closeConfirms();
        if (ask) ask.focus();
      } else if (event.target.closest('[data-kck-clear-yes]')) {
        closeConfirms();
        if (box.getAttribute('data-kck-clearbox') === 'hazir') {
          hazir = {};
          var back = state.mode === 'hazir' && state.hzStep === 2;
          if (back) state.hzStep = 1;
          render(back);
        } else {
          Set.save([]);
        }
      }
    });

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest ? event.target.closest('[data-kck-to]') : null;
      if (!trigger) return;
      event.preventDefault();
      var target = trigger.getAttribute('data-kck-to');
      var before = currentView();
      closeConfirms();
      if (target === 'restart-set') {
        state.done = '';
        state.step = firstStep();
        state.packs = [];
        state.packOther = '';
        state.qty = defaultQty;
        state.customQty = '';
        state.cat = 'tum';
        state.mode = 'set';
        Set.save([]);
        render(true);
        return;
      }
      if (target === 'restart-hazir') {
        state.done = '';
        state.hzStep = 1;
        state.mode = 'hazir';
        hazir = {};
        render(true);
        return;
      }
      /* Devam düğmesi: bulunulan adımdan, seçili sıradaki sonraki adıma */
      if (target === 'next') {
        var here = trigger.closest('[data-kck-bview]');
        var at = here ? seq().indexOf(here.getAttribute('data-kck-bview')) : -1;
        target = seq()[at + 1] || 'set3';
      }
      /* Devam düğmeleri o adım tamamlanmadan geçirmez */
      var need = trigger.getAttribute('data-kck-need');
      if (need === 'items' && Set.items().length === 0) {
        warn('set1', text.warnItems);
        return;
      }
      if (need === 'pack' && state.packs.length === 0) {
        warn('set2', text.warnPack);
        return;
      }
      /* Son adıma eksikle geçilmez: eksik olan adım açılır ve ne gerektiği yazılır */
      var message = null;
      var gap = target === 'set3' ? missing() : null;
      if (gap) {
        target = gap[0];
        message = gap;
      } else if (target === 'hz2' && Object.keys(hazir).length === 0) {
        target = 'hz1';
        message = ['hz1', text.warnHazir];
      }
      state.done = '';
      if (target.indexOf('set') === 0) {
        state.mode = 'set';
        state.step = parseInt(target.slice(3), 10) || 1;
      } else if (target.indexOf('hz') === 0) {
        state.mode = 'hazir';
        state.hzStep = parseInt(target.slice(2), 10) || 1;
      }
      warn('set1', '');
      warn('set2', '');
      warn('hz1', '');
      if (message) warn(message[0], message[1]);
      var moved = currentView() !== before;
      /* Adım düğmesine basıldıysa sayfa yerinde kalır; başka yerden gelindiyse adımlar ekranın başına alınır */
      render(moved && !trigger.closest('[data-kck-anchor]'));
      if (moved && message && message[0] === 'set2') scrollTo(root.querySelector('[data-kck-pack-anchor]'));
    });

    document.addEventListener('kck:set', function () {
      if (Set.items().length) warn('set1', '');
      /* Son adımda set boşaldıysa ürün adımına dönülür */
      var back = state.mode === 'set' && state.step === 3 && !state.done && Set.items().length === 0;
      if (back) state.step = 1;
      render(back);
    });

    var rollFrame = 0;
    window.addEventListener('resize', function () {
      window.cancelAnimationFrame(rollFrame);
      rollFrame = window.requestAnimationFrame(roll);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(roll);

    /* Sunucudan gelen durum: gönderildi ya da form hatası */
    var initial = root.getAttribute('data-kck-initial') || '';
    var last = session(LAST_FORM_KEY) || '';
    if (initial === 'done') {
      state.done = last === 'hazir' ? 'hazir' : 'set';
      state.mode = state.done;
      if (state.done === 'hazir') {
        hazir = {};
        state.hzStep = 1;
      } else {
        state.step = firstStep();
        state.packs = [];
        state.packOther = '';
        state.qty = defaultQty;
        state.customQty = '';
        write(SET_KEY, []);
      }
      session(LAST_FORM_KEY, null);
    } else if (initial === 'error') {
      if (last === 'hazir') {
        state.mode = 'hazir';
        state.hzStep = 2;
      } else {
        state.mode = 'set';
        state.step = 3;
      }
    } else {
      /* Adım sırası gelinen yere göre seçilir: Dükkandan (set çubuğu, ürün sayfası: ?adim=urunler) bir sıra,
         Teklif Al'dan ya da doğrudan gelince öbür sıra. Yenilemede ya da geri tuşunda sıra da korunur. */
      if (param('adim') === 'urunler') state.order = orderShop;
      else if (arrival() === 'navigate') state.order = orderDefault;
      /* Sayfaya yeni gelindiğinde hep aynı yer açılır: ilk sekme, o sıranın ilk adımı.
         Yenilemede ya da geri tuşunda kalınan yer korunur. */
      if (arrival() === 'navigate') {
        state.mode = 'set';
        state.step = firstStep();
        state.hzStep = 1;
      }
      var wanted = param('yol') || (window.location.hash || '').replace('#', '');
      if (wanted === 'hazir' || wanted === 'set') state.mode = wanted;
      /* ?adim=urunler | paketleme | bilgiler: bağlantı belirli bir adımı açabilir */
      var wantedStep = { urunler: 1, paketleme: 2, bilgiler: 3 }[param('adim')] || 0;
      if (wantedStep) {
        state.mode = 'set';
        state.step = wantedStep;
        try {
          var query = new URLSearchParams(window.location.search);
          query.delete('adim');
          var rest = query.toString();
          window.history.replaceState(null, '', window.location.pathname + (rest ? '?' + rest : '') + window.location.hash);
        } catch (error) {}
      }
      /* Seçim yapılmadan son adımda açılmasın */
      var gapAtStart = state.step === 3 ? missing() : null;
      if (gapAtStart) state.step = parseInt(gapAtStart[0].slice(3), 10);
      if (state.hzStep === 2 && Object.keys(hazir).length === 0) state.hzStep = 1;
    }
    if (!state.step) state.step = firstStep();

    applyOrder();
    warn('set1', '');
    warn('set2', '');
    warn('hz1', '');
    render(false);
    syncAddButtons();
    if (initial === 'done' || initial === 'error') {
      window.setTimeout(function () {
        scrollTo(root.querySelector('[data-kck-anchor]') || root);
      }, 150);
    }
  }

  /* ---------- Başlangıç ---------- */

  function boot() {
    all(document, '[data-kck-pick]').forEach(initPick);
    all(document, '[data-kck-form]').forEach(initForm);
    all(document, '[data-kck-views]').forEach(initViews);
    all(document, '[data-kck-gallery]').forEach(initGallery);
    all(document, '[data-kck-prose]').forEach(tidyProse);
    all(document, '[data-kck-dukkan]').forEach(initDukkan);
    all(document, '[data-kck-builder]').forEach(initBuilder);
    initProduct();
    syncAddButtons();
    syncBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('resize', syncBar);
})();
